// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export const formStyles = {
  root: {
    width: 300
  }
};
